import gql from 'graphql-tag'

import { UserAuthLogoutMutation } from '../../../../generated/graphql'

const authLogout = {
  mutation: gql`
    mutation UserAuthLogout {
      authLogout
    }
  `,
  transformer: (response: UserAuthLogoutMutation) => {
    return response
  },
}

export default authLogout
